// extracted by mini-css-extract-plugin
export default {"item":"MessageTemplateListItem_item__zm1Aa","titleContainer":"MessageTemplateListItem_titleContainer__fz4Bh","isDefaultIcon":"MessageTemplateListItem_isDefaultIcon__TmlBH"};